export default "__VITE_ASSET__acdd5fea__"